import type { OosDateRange, OosTagMatch } from './services/LurkerApiService';

export const LURKER_ROOT = '/lurker';
/** Strategies compared over the labelled camera-days. */
export const LURKER_DASHBOARD_PATH = `${LURKER_ROOT}/dashboard`;
/** Snapshotted camera-days, and those with results waiting for a snapshot. */
export const LURKER_CAMERA_DAYS_PATH = `${LURKER_ROOT}/camera-days`;
export const LURKER_STRATEGIES_PATH = `${LURKER_ROOT}/strategies`;
/** OOS Labeling: batches of crops frozen from production for bulk labelling. */
export const LURKER_LABELING_PATH = `${LURKER_ROOT}/labeling`;

export const lurkerBatchPath = (batchId: string) =>
  `${LURKER_LABELING_PATH}/${encodeURIComponent(batchId)}`;

/** Relabel: blind sessions over the crops a flag model or a person sent back for another look. */
export const LURKER_RELABEL_PATH = `${LURKER_ROOT}/relabel`;

/** A relabel session: blind while open, its reveal once finished. */
export const lurkerRelabelSessionPath = (sessionId: string) =>
  `${LURKER_RELABEL_PATH}/${encodeURIComponent(sessionId)}`;

/**
 * The camera-days list filtered to any (or all) of the tags. Without tags it lists the given dates,
 * or the page's default ones.
 */
export function lurkerCameraDaysPath(
  tags: string[],
  tagMatch: OosTagMatch = 'any',
  range?: OosDateRange
) {
  const query = new URLSearchParams(tags.map((tag) => ['tag', tag]));
  if (tags.length && tagMatch === 'all') query.set('tagMatch', 'all');
  if (range) {
    query.set('from', range.firstDate);
    query.set('to', range.lastDate);
  }
  const params = query.toString();
  return params ? `${LURKER_CAMERA_DAYS_PATH}?${params}` : LURKER_CAMERA_DAYS_PATH;
}

export type OosCameraDayView = 'timelines' | 'images';

/** One camera-day in its labelling view. */
export const lurkerCameraDayPath = (cameraDayId: string, view: OosCameraDayView = 'timelines') =>
  `${LURKER_CAMERA_DAYS_PATH}/${encodeURIComponent(cameraDayId)}/${view}`;
